import { render, staticRenderFns } from "./ChatBoxModalAssignTo.vue?vue&type=template&id=5dc7b897&scoped=true&"
import script from "./ChatBoxModalAssignTo.vue?vue&type=script&lang=js&"
export * from "./ChatBoxModalAssignTo.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxModalAssignTo.vue?vue&type=style&index=0&id=5dc7b897&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc7b897",
  null
  
)

export default component.exports